module.exports = __webpack_public_path__ + "icon-twitter.svg";